export const LOGIN = 'LOGIN'
export const USERAUTHCORRECT = 'USERAUTHCORRECT'
export const CLOSESESSION = 'CLOSESESSION'
export const SECONDCONFIRM = 'SECONDCONFIRM'